if (!customElements.get('product-showcase-gallery')) {
  customElements.define('product-showcase-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return; this.initialized = true;
      const dialog = this.querySelector('dialog');
      if (!dialog || !dialog.showModal) return;
      this.querySelectorAll('[data-preview-image]').forEach(link => {
        link.addEventListener('click', event => {
          event.preventDefault();
          const image = dialog.querySelector('img');
          image.src = link.href;
          image.alt = link.querySelector('img').alt;
          dialog.showModal();
        });
      });
      dialog.querySelector('[data-close-preview]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    }
  });
}

if (!customElements.get('product-showcase-add-form')) {
  customElements.define(
    'product-showcase-add-form',
    class ProductShowcaseAddForm extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return; this.initialized = true;
        this.form = this.querySelector('form');
        this.button = this.querySelector('[type="submit"]');
        this.buttonText = this.button.querySelector('span');
        this.defaultText = this.buttonText.textContent;
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      onSubmit(event) {
        event.preventDefault();
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        this.button.setAttribute('aria-disabled', 'true');

        const formData = new FormData(this.form);
        formData.set('sections', 'cart-icon-bubble');
        formData.set('sections_url', window.location.pathname);

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.buttonText.textContent = response.description || response.message || 'Error';
            } else {
              this.buttonText.textContent = 'Added';
              return this.updateCartCount(response.sections?.['cart-icon-bubble']);
            }
          })
          .catch(() => {
            this.buttonText.textContent = 'Error';
          })
          .finally(() => {
            setTimeout(() => {
              this.buttonText.textContent = this.defaultText;
              this.button.removeAttribute('aria-disabled');
            }, 1500);
          });
      }

      async updateCartCount(sectionHTML) {
        const bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        // The section response contains the icon's contents, not the header link id.
        if (typeof sectionHTML === 'string' && sectionHTML.trim()) {
          const doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
          const section = doc.getElementById('shopify-section-cart-icon-bubble') || doc.body;
          if (section.querySelector('.svg-wrapper')) {
            bubble.innerHTML = section.innerHTML;
            bubble.setAttribute('aria-live', 'polite');
            return;
          }
        }
        // Shopify can accept the item while section rendering fails. Read the real total.
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart.js`, {cache: 'no-store', headers: {Accept: 'application/json'}});
          if (!response.ok) throw new Error('Cart unavailable');
          const cart = await response.json();
          if (!Number.isInteger(cart.item_count) || cart.item_count < 0) throw new Error('Invalid cart');
          let badge = bubble.querySelector('.cart-count-bubble');
          if (!badge && cart.item_count > 0) {
            badge = document.createElement('div'); badge.className = 'cart-count-bubble'; bubble.append(badge);
          }
          if (badge) {
            badge.hidden = cart.item_count === 0;
            const visible = document.createElement('span'); visible.setAttribute('aria-hidden', 'true'); visible.textContent = String(cart.item_count);
            const label = document.createElement('span'); label.className = 'visually-hidden'; label.textContent = `${cart.item_count} items`;
            badge.replaceChildren(visible, label);
          }
          bubble.setAttribute('aria-live', 'polite');
        } catch (_) {
          this.buttonText.textContent = 'Added — refresh to update count';
        }
      }
    }
  );
}

